import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

// Project survey for the Proposal Support Service (service2), defined in survey_project_pss.json.
// Question keys must not contain '.': validation looks controls up with form.get(key), which splits on dots.
// Every question is required except the ones listed here.
const OPTIONAL_KEYS = new Set<string>([
  'What could be improved?',
])

export function loadPssProjectSurvey(): { title: string, questions: { [key: string]: any }[] } {
  return require(`assets/meeting-form/survey_project_pss.json`)
}

export function pssProjectSurveyRequiredKeys(questions: { [key: string]: any }[]): string[] {
  return questions.map(q => Object.keys(q)[0]).filter(key => !OPTIONAL_KEYS.has(key))
}

export function buildPssProjectSurveyForm(): FormGroup {
  const questions = loadPssProjectSurvey().questions
  const required = new Set(pssProjectSurveyRequiredKeys(questions))
  const group = new FormGroup({})
  for (const question of questions) {
    const key = Object.keys(question)[0]
    const isRequired = required.has(key)
    if (Array.isArray(question[key])) {
      group.addControl(key, new FormArray([], isRequired ? Validators.required : null))
      // tick-box adds the "- Other" control only once rendered; create it upfront so saved values load back
      if (question[key].some((answer: string) => /\(please specify\)/i.test(answer)))
        group.addControl(`${key} - Other`, new FormControl(''))
    }
    else
      group.addControl(key, new FormControl('', isRequired ? Validators.required : null))
  }
  return group
}
